import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGlobalAccount, getClubList } from '../../store/selectors';
import { requestCareerData, toggleCareerMenu } from '../../store/actionCreators/career';
import '../../assets/stylesheets/ClubSlide/ClubMainContent.scss';
import '../../assets/stylesheets/CareerSlide/CareerPage.scss';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import CareerMenu from './components/Menu';
import CareerTitle from './components/Title';
import CareerPeriods from './components/Periods';
import CareerChart from './components/Chart';
import CareerDateRange from './components/DateRange';
import CareerReports from './components/Reports';
import defaults from '../../config/career';
import moment from 'moment';

const { dateItems, formats, periodLabels, periodTicks, data, initialDate, defaultTicks, defaultLabels, gameTypes } = defaults;

const Career = ({}) => {

    const dispatch = useDispatch();
    const careerData = useSelector(state => state.careerData);
    const careerMenu = useSelector(state => state.careerMenu);
    const clubsList = useSelector(getClubList);

    const [selectedPeriod, setPeriod] = useState(dateItems[0]);
    const [selectedDate, setSelectedDate] = useState(initialDate);
    const [selectedGame, setSelectedGame] = useState([gameTypes[1]]);
    const [selectedClub, setSelectedClub] = useState(clubsList[clubsList.length - 1]);
    const [isLoading, setLoader] = useState(false);
    const [graphData, setGraphData] = useState(data);

    const filterAxesLabels = (value, index, values) => {
        for (let l in defaultLabels[selectedPeriod]) {
            if (defaultLabels[selectedPeriod][l] === value) {
                return value;
            }
        }
    }

    const selectDate = useCallback((direction) => {
        const currentSelection = selectedDate;
        
        const localDate = (direction === "left") ? {
            start: moment(currentSelection[selectedPeriod].start).subtract(1, selectedPeriod).format('YYYY/MM/DD'),
            end: moment(currentSelection[selectedPeriod].end).subtract(1, selectedPeriod).format('YYYY/MM/DD'),
        } : ((moment(currentSelection[selectedPeriod].end) >= moment()) ?
            {
                start: (selectedPeriod !== "day") ? moment().startOf(selectedPeriod).format('YYYY/MM/DD') :  moment().format('YYYY/MM/DD'),
                end: (selectedPeriod !== "day") ? moment().endOf(selectedPeriod).format('YYYY/MM/DD') : moment().add(1, selectedPeriod).format('YYYY/MM/DD'),
            } : {
                start: moment(currentSelection[selectedPeriod].start).add(1, selectedPeriod).format('YYYY/MM/DD'),
                end: moment(currentSelection[selectedPeriod].end).add(1, selectedPeriod).format('YYYY/MM/DD'),
            });
        currentSelection[selectedPeriod] = localDate;
        setSelectedDate({...currentSelection});
    }, [selectedPeriod, selectedDate, setSelectedDate]);

    useEffect(() => {
        let currentGraphData = graphData;
        currentGraphData.labels = periodLabels[selectedPeriod];
        currentGraphData.options.scales.xAxes[0].ticks = {
            ...defaultTicks.x,
            callback: filterAxesLabels
        };
        setGraphData(currentGraphData);
        setSelectedDate({...selectedDate});
    }, [selectedPeriod]);

    useEffect(() => {
        let selectedProducts = selectedGame.map(game => game.productId);
        if (typeof selectedProducts[0] !== 'number') {selectedProducts = selectedProducts[0]}
        dispatch(requestCareerData({
            type: selectedPeriod,
            productId: selectedProducts,
            dateFrom: selectedDate[selectedPeriod].start,
            dateTo: selectedDate[selectedPeriod].end,
            skinId: selectedClub.clubId
        }))
    }, [selectedDate, selectedGame, selectedClub]);

    useEffect(() => {
        const localData = [];
        const labels = [];
        careerData.playerWinLoss && careerData.playerWinLoss.map(item => {
            let x;
            x = moment(item.date).format(formats.period[selectedPeriod]);
            x = parseInt(x);
            labels.push(x);
            item = { x: periodTicks[selectedPeriod][x], y: item.wl }
            localData.push(item);
        });
        let myArray = [...localData];
        myArray.sort(function (a, b) {
            return a.y - b.y
        });
        let mySteps = localData;
        mySteps.sort(function (a, b) {
            return a.x - b.x
        });
        
        let min = myArray[0],
            max = myArray[myArray.length - 1],
            step = (min && max) && Math.round((Math.abs(min.y) + Math.abs(max.y)) / 5);

        let currentGraphData = graphData;
        currentGraphData.options.scales.yAxes[0].ticks = {
            ...currentGraphData.options.scales.yAxes[0].ticks,
            suggestedMin: min ? min.y : defaultTicks.y.suggestedMin,
            suggestedMax: max ? max.y : defaultTicks.y.suggestedMax,
            stepSize: step ? step : defaultTicks.y.stepSize
        }
        if (mySteps.length === 1) {
            currentGraphData.options.scales.yAxes[0].ticks.suggestedMin = myArray[0].y - Math.abs(myArray[0].y);
            currentGraphData.options.scales.yAxes[0].ticks.suggestedMax =  myArray[0].y + Math.abs(myArray[0].y);
            currentGraphData.options.scales.yAxes[0].ticks.stepSize = Math.abs(myArray[0].y);
        }
        currentGraphData.options.scales.xAxes[0].ticks = {
            ...defaultTicks.x,
            callback: filterAxesLabels
        };
        currentGraphData.labels = periodLabels[selectedPeriod];
        setGraphData({...currentGraphData, datasets: [{...currentGraphData.datasets[0], data: localData }] })
    }, [careerData]);

    return (
        <div className="careerPage">

            <CareerTitle selectedGame={selectedGame} selectedClub={selectedClub}></CareerTitle>

            <CareerPeriods dateItems={dateItems} selectedPeriod={selectedPeriod} setPeriod = {setPeriod} ></CareerPeriods>

            {
                (isLoading) ?
                <div className="loadingSpinner">
                    <FontAwesomeIcon icon={faSpinner} color="white" spin> </FontAwesomeIcon>
                </div> :
                <div className="careerGraphs">

                    <CareerChart graphData={graphData} selectDate={selectDate} ></CareerChart>

                    <div className="careerGameHistory">

                        <CareerDateRange selectedDate={selectedDate} selectedPeriod={selectedPeriod} formats={formats} careerData={careerData}></CareerDateRange>

                    </div>

                    <CareerReports careerData={careerData} formats={formats} selectedPeriod={selectedPeriod} ></CareerReports>

                </div>
            }

            {
                careerMenu && 
                <CareerMenu selectedGame={selectedGame} setSelectedGame={setSelectedGame} selectedClub={selectedClub} setSelectedClub={setSelectedClub} />
            }
        </div>
    )
};

export default Career;